// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__zfMHP","search":"Settings_search__1PrGB","filter":"Settings_filter__1EKcn"};